import React from "react";

import { Button } from "components/Button";
import { Input } from "components/Input";
import { Page } from "components/Page";
import { useAuthContext } from "context/AuthContext";

export const Login = () => {
  const { login, isLoading, error } = useAuthContext();

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const email = formData.get("email");
    const password = formData.get("password");

    login(email, password);
  };

  return (
    <Page>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">iTint Academy Admin</h2>
        </div>

        <div className="mt-4 rounded-lg border px-3 pb-3 shadow sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <Input id="email" name="email" type="email" placeholder="user@email.com" autoComplete="email" required label="Email" />
            </div>

            <div>
              <Input id="password" name="password" placeholder="••••••••" type="password" autoComplete="current-password" required label="Password" />
            </div>

            <div>
              {error && <p className="mb-2 text-red-500 ">{error?.response?.data?.error ?? error.message}</p>}
              <Button color="primary" size="sm" className="w-full" type="submit" disabled={isLoading} loading={isLoading}>
                Sign in
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Page>
  );
};
